/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const inventoryItemSplitResultDataSchema = z.object({
	original: z.object({
		id: z.string(),
		catalogueItemType: z.string(),
		valueCents: z.number(),
		quantity: z.number(),
		availableQuantity: z.number(),
		description: z.string().nullable(),
		expiresAt: z.iso.datetime(),
		isExpired: z.boolean(),
		createdAt: z.iso.datetime(),
	}),
	new: z.array(
		z.object({
			id: z.string(),
			catalogueItemType: z.string(),
			valueCents: z.number(),
			quantity: z.number(),
			availableQuantity: z.number(),
			description: z.string().nullable(),
			expiresAt: z.iso.datetime(),
			isExpired: z.boolean(),
			createdAt: z.iso.datetime(),
		}),
	),
})

export type InventoryItemSplitResultDataSchema = z.infer<typeof inventoryItemSplitResultDataSchema>
